// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wefzB","imageContainer":"styles_imageContainer__LrMSJ","walletIcon":"styles_walletIcon__Q1bXk","buttonContainer":"styles_buttonContainer__OIjaW"};